import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { verifyEmailUrl } from "../../api";
import { isLoading, setLoading } from "../../redux/loadingSlice";
import { PageLoader } from "../core";

export const EmailVerify = () => {
  const [validUrl, setValidUrl] = useState(false);
  const param = useParams();
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);

  useEffect(() => {
    dispatch(setLoading(false));
    const verifyEmail = async () => {
      const requestData = {
        operation: "verifyEmailToken",
        request: {
          id: param.id,
          type: param.type,
          token: param.token,
        },
      };
      const resp = await verifyEmailUrl(requestData);
      dispatch(setLoading(true));
      if (resp?.responseCode === 200) {
        setValidUrl(true);
      } else {
        setValidUrl(false);
      }
    };
    verifyEmail();
  }, [param, setValidUrl, dispatch]);

  return (
    <div>
      <div className="min-h-screen flex items-center justify-center">
        {validUrl && (
          <div className="flex flex-col items-center space-y-4">
            <div className="text-black items-center justify-center">
              <h2 className="text-2xl font-medium text-gray-600 mt-4">
                Email Verified Successfully
              </h2>
            </div>
            <div className="items-center justify-center">
              You can now close this tab and update service provider
            </div>
          </div>
        )}
        {loading && !validUrl && (
          <div className="flex flex-col items-center space-y-4">
            <div className="text-black items-center justify-center">
              <h2 className="text-2xl font-medium text-gray-600 mt-4">
                Unable to verify your Email address
              </h2>
            </div>
            <div className="items-center justify-center">
              Either token is invalid or it has expired. Please close this page
              and try again
            </div>
          </div>
        )}
        {!loading && <PageLoader />}
      </div>
    </div>
  );
};